import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetResultByDimensionAmbassador state domain
 */

const selectWidgetResultByDimensionAmbassadorDomain = (state) =>
  state.get("widgetResultByDimensionAmbassador", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingDimensions = () =>
  createSelector(selectWidgetResultByDimensionAmbassadorDomain, (state) =>
    state.get("isLoadingDimensions")
  )

export const makeSelectDimensionsDrillDown = () =>
  createSelector(selectWidgetResultByDimensionAmbassadorDomain, (state) =>
    state.get("dimensionsDrillDown")
  )

export const makeSelectDivisions = () =>
  createSelector(selectWidgetResultByDimensionAmbassadorDomain, (state) =>
    state.get("divisions")
  )

export const makeSelectShowDimensionBenchmark = () =>
  createSelector(selectWidgetResultByDimensionAmbassadorDomain, (state) =>
    state.get("showDimensionBenchmark")
  )

/**
 * Default selector used by WidgetResultByDimensionAmbassador
 */

const makeSelectWidgetResultByDimensionAmbassador = () =>
  createSelector(selectWidgetResultByDimensionAmbassadorDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetResultByDimensionAmbassador
export { selectWidgetResultByDimensionAmbassadorDomain }
